import { formatCurrency } from './utils.currency';

const AUTO_CLOSING_AFTER_SECONDS = 10;
const MAX_COUNTEROFFER_DIGITS = 6;

export const parseAmount = (amount: string = ''): string =>
  amount
    .replace(/[^0-9]/g, '')
    .replace(/^0/, '')
    .substring(0, MAX_COUNTEROFFER_DIGITS);

export const formatAmount = (amount: string | number): string => amount && formatCurrency(amount);

const modalsAutoClosed = new Map<HTMLIcoModalElement, boolean>();

export const scheduleAutoClosing = (modal: HTMLIcoModalElement) => {
  modalsAutoClosed.set(modal, false);
  setTimeout(() => {
    modalsAutoClosed.set(modal, true);
    modal.close();
  }, AUTO_CLOSING_AFTER_SECONDS * 1000);
};
export const isClosedByUser = (modal: HTMLIcoModalElement) => !modalsAutoClosed.get(modal);
